export const SKELETON_CONSTANTS = {
  RIGHT_SIDEBAR: {
    STORE_CARD_COUNT: 4
  }
} as const;
